import useClaims from "./useClaims";
import {GET_ALL_COMPANIES} from "../Claims";
import {useContext, useEffect, useState} from "react";
import {SalvoContext} from "../contexts/SalvoContext";

export default function useImpersonation()
{
    const { selectedCompany } = useContext(SalvoContext)
    const [canImpersonate, setCanImpersonate] = useState(false)
    const [isImpersonating, setIsImpersonating] = useState(false)

    const {hasClaim, claims} = useClaims()


    useEffect(() => {
        setCanImpersonate(hasClaim(GET_ALL_COMPANIES))
    }, [claims, hasClaim]);

    useEffect(() => {
        setIsImpersonating(selectedCompany != null)
    }, [selectedCompany]);


    const viewAs = selectedCompany
    return { canImpersonate, isImpersonating, viewAs }
}